import type { BlogPost } from "./api";

/**
 * Cover-art gradients, stored on a post as `coverStyle` (legacy blogConstants.js). Without one, a
 * post gets a gradient derived from its slug, so it always looks the same.
 */
export const COVER_STYLES: Record<string, string> = {
  t1: "linear-gradient(135deg,#0f2f6e,#2563eb)",
  t2: "linear-gradient(135deg,#134e4a,#0ea5a4)",
  t3: "linear-gradient(135deg,#4c1d95,#7c3aed)",
  t4: "linear-gradient(135deg,#7c2d12,#ea7a3c)",
  t5: "linear-gradient(135deg,#0c4a6e,#38bdf8)",
  t6: "linear-gradient(135deg,#334155,#64748b)",
};
export const COVER_KEYS = Object.keys(COVER_STYLES);

export const CATEGORIES = ["Planning", "Behaviour", "Retirement", "Taxes", "Product", "General"];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function coverGradient(post: Pick<BlogPost, "coverStyle" | "slug" | "title">): string {
  const key =
    post.coverStyle && COVER_STYLES[post.coverStyle]
      ? post.coverStyle
      : COVER_KEYS[hash(post.slug || post.title || "") % COVER_KEYS.length];
  return COVER_STYLES[key];
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
}

export function readTime(markdown: string | null | undefined): number {
  const words = (markdown || "").trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export function authorInitials(name: string | null | undefined): string {
  return (name || "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");
}

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
